import React from 'react';

const Member = ({member}) => {
  const {name,avatar,id}=member;
  return (
    <div> <div className="checkbox-container">
    <img src={`http://localhost:9000${avatar}`} className="team-avater" />
    <p className="label">{name}</p>
  </div></div>
  )
}

export default Member